import * as React from 'react';
import { Main } from './Components/Main';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import MWContextProvider from './Contexts/MWContext';
import AuthContextProvider from './Contexts/AuthContext';
import CartContextProvider from './Contexts/CartContext';

function App() {

  return (
    <MWContextProvider>
      <AuthContextProvider>
        <CartContextProvider>
          <DndProvider backend={HTML5Backend}>
            <div className="App">
              <Main />
            </div>
          </DndProvider>
        </CartContextProvider>
      </AuthContextProvider>
    </MWContextProvider>
  );
}

export default App;
